<template>
  <popover-box class="form-popover" ref="popover" :parent="parent" :direction="direction">
    <slot></slot>
    <div>
      <action-button
        class="form-popover__submit-button"
        @click.native="clickedSubmit"
        label="Submit"
        color="secondary"
      ></action-button>
    </div>
  </popover-box>

</template>

<script>

import PopoverBox from '../builderComponents/PopoverBox'
import popoverContainerMixin from '../builderComponents/popoverContainerMixin'
import ActionButton from '@/components/common/actionButton'

export default {
  components: {
    PopoverBox,
    ActionButton
  },
  props: {
    parent: HTMLDivElement,
    direction: String
  },
  mixins: [popoverContainerMixin],
  methods: {
    clickedSubmit () {
      this.$emit('submit')
    }
  }
}

</script>

<style lang="scss">
.form-popover {
  &__submit-button {
    float: right;
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// FormPopover.vue?3e9e66c1